module.exports = __webpack_public_path__ + "img/img7233.a0040717.jpg";